import { useAthosContext } from '../fetchers/provider'
import { calculateProductCount } from '../helpers/productCount'

export function ResultCount({ className }) {
  const { results } = useAthosContext()
  const total = calculateProductCount(results)
  const itemLabel = total === 1 ? 'Item' : 'Items'
  return <p className={className}>{total} {itemLabel}</p>
}
